module.exports = __webpack_public_path__ + "img/footer_official_accounts_qr.44be6b69.png";